// extracted by mini-css-extract-plugin
export default {"groupHeading":"styles_groupHeading__Ks4K6","label":"styles_label__KhSks"};